import { Directive, ElementRef, Renderer2 } from '@angular/core';
import { Store } from '@ngrx/store';
import { combineLatest } from 'rxjs';
import { AppState } from '../../../reducers';
import { LeadCreationUserDataModel } from '../../../modules/sales/models/lead';
import { LeadOutcomeStatusNames } from '../../../modules/sales/shared/utils/sales-module.enums';
import { selectLeadCreationUserDataState$ } from '../../../modules/sales/components/task-management/lead-creation-ngrx-files/lead-creation.selectors';

@Directive({
  selector: '[disableUserAction]'
})
export class DisableUserActionDirective {
  leadCreationUserDataModel: LeadCreationUserDataModel;
  leadOutcomeStatusNames = LeadOutcomeStatusNames;

  constructor(private renderer: Renderer2, private el: ElementRef, private store: Store<AppState>) {

  }

  combineLatestNgrxStoreData() {
    combineLatest([this.store.select(selectLeadCreationUserDataState$)])
      .subscribe((response) => {
        this.leadCreationUserDataModel = new LeadCreationUserDataModel(response[0]);
        if (this.leadCreationUserDataModel?.leadStatusName == this.leadOutcomeStatusNames.NO_SALE ||
          this.leadCreationUserDataModel?.leadStatusName == this.leadOutcomeStatusNames.SALE_COMPLETED) {
          this.renderer.setStyle(this.el.nativeElement, 'pointer-events', 'none');
        }
        else {
          this.renderer.setStyle(this.el.nativeElement, 'pointer-events', 'all');
        }
      });
  }

  ngOnInit() {
    setTimeout(() => {
      this.combineLatestNgrxStoreData();
    }, 500);
  }
}